import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })

export async function reporteDiurno (context,payload){
    try{
    let url = "access/reporteturno/_por_dia_diurno"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function reporteNocturno (context,payload){
    try{
        let url = "access/reporteturno/_por_dia_nocturno"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('dia',payload.dia)  
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
        }catch(error){
            context.commit('setError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
